import { apiClient } from '../client';

// A deliberately loose subset of OpenAPI 3 — only what the API Docs page renders.

export interface OpenApiParameter {
  name: string;
  in: 'query' | 'path' | 'header' | 'cookie';
  required?: boolean;
  description?: string;
  schema?: OpenApiSchema;
  example?: unknown;
  $ref?: string;
}

export interface OpenApiSchema {
  type?: string;
  format?: string;
  enum?: unknown[];
  items?: OpenApiSchema;
  properties?: Record<string, OpenApiSchema>;
  required?: string[];
  description?: string;
  example?: unknown;
  $ref?: string;
  nullable?: boolean;
  minimum?: number;
  maximum?: number;
  default?: unknown;
  pattern?: string;
  additionalProperties?: boolean | OpenApiSchema;
}

export interface OpenApiOperation {
  tags?: string[];
  summary?: string;
  description?: string;
  parameters?: OpenApiParameter[];
  requestBody?: { required?: boolean; content?: Record<string, { schema?: OpenApiSchema; example?: unknown }> };
  responses?: Record<string, { description?: string; $ref?: string; content?: Record<string, { schema?: OpenApiSchema }> }>;
  security?: unknown[];
}

export type OpenApiPathItem = Partial<Record<'get' | 'post' | 'put' | 'patch' | 'delete', OpenApiOperation>> & {
  parameters?: OpenApiParameter[];
};

export interface OpenApiDocument {
  openapi: string;
  info: { title: string; version: string; description?: string };
  servers?: { url: string }[];
  paths: Record<string, OpenApiPathItem>;
  components?: {
    schemas?: Record<string, OpenApiSchema>;
    parameters?: Record<string, OpenApiParameter>;
  };
}

/** GET /openapi.json — public, no auth needed. */
export async function getOpenApi(): Promise<OpenApiDocument> {
  const { data } = await apiClient.get<OpenApiDocument>('/openapi.json');
  return data;
}
